module.exports = __webpack_public_path__ + "img/ico_badge16.4b5d942b.svg";